// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GSk0HVsePm {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.GSk0HVsePm h4 {
  line-height: 3em;
}
.GSk0HVsePm .GTb2GT7yyb {
  float: left;
  width: 100%;
}
.GSk0HVsePm .KV0MFBItKn {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.GSk0HVsePm .KV0MFBItKn:hover {
  cursor: pointer;
}
.GSk0HVsePm .KV0MFBItKn:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.JcFslAH1Wx .KMK5q5zOT6:focus {
  outline: none;
}
.JcFslAH1Wx .KMK5q5zOT6.puDx9f2q3X.N5x3KVtz4a {
  background: #375A88;
}
.JcFslAH1Wx .KMK5q5zOT6.puDx9f2q3X.N5x3KVtz4a span {
  color: #fff;
}
.JcFslAH1Wx .N5x3KVtz4a {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.JcFslAH1Wx .N5x3KVtz4a:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.JcFslAH1Wx input {
  height: 38px;
  min-width: 220px;
}
.KV0MFBItKn.KeM1XqFb48 {
  background: #410102;
}
.KV0MFBItKn.D0zJNLxFMc {
  background: #911318;
}
.KV0MFBItKn.TgcPJbBPu9 {
  background: #D8293B;
}
.KV0MFBItKn.yVITea9Bgg {
  background: #F2373C;
}
.KV0MFBItKn.lA87mL9vbc {
  background: #FC4448;
}
.KV0MFBItKn.XEg79eUX1U {
  background: #ED535E;
}
.KV0MFBItKn.Y8Hzgqd_16 {
  background: #E34926;
}
.KV0MFBItKn.Sc4Snr2g0d {
  background: #FC562B;
}
.KV0MFBItKn.ldflf01xLC {
  background: #FC6722;
}
.KV0MFBItKn.hS0_i_Rzx7 {
  background: #FD7F24;
}
.KV0MFBItKn.hsGW4UzFe6 {
  background: #FD8D26;
}
.KV0MFBItKn.nBF9prrzz3 {
  background: #EC9C3E;
}
.KV0MFBItKn.TBGTFtNZ45 {
  background: #0e673a;
}
.KV0MFBItKn.loSOyM0NZp {
  background: #208740;
}
.KV0MFBItKn.mcFA2agBOs {
  background: #239718;
}
.KV0MFBItKn.zDcuW0Ninw {
  background: #55A84D;
}
.KV0MFBItKn.UsSGfRSu9j {
  background: #4BBE5A;
}
.KV0MFBItKn.LEHqmBVRlo {
  background: #0CCA6A;
}
.KV0MFBItKn.GW2ynH0BhY {
  background: #0A3C64;
}
.KV0MFBItKn.G_Lu6QLngZ {
  background: #0d487a;
}
.KV0MFBItKn.bMAXY3JMl4 {
  background: #10538d;
}
.KV0MFBItKn.UGIKCQVAaB {
  background: #115A99;
}
.KV0MFBItKn.VfATB2oFOe {
  background: #3387E2;
}
.KV0MFBItKn.EgcBet5ExD {
  background: #1BA9CF;
}
.KV0MFBItKn.mddiS1knaD {
  background: #d27c02;
}
.KV0MFBItKn.Jz5QVD0ubT {
  background: #fb9402;
}
.KV0MFBItKn.rbNlL90SAV {
  background: #FD9B30;
}
.KV0MFBItKn.tPHXdmmPwC {
  background: #FDBE2D;
}
.KV0MFBItKn.iCgUMlyQk3 {
  background: #FED831;
}
.KV0MFBItKn.bL2k7Bo_eC {
  background: #FFFD38;
}
.KV0MFBItKn.ZtXELSjfvU {
  background: #2D215C;
}
.KV0MFBItKn.w9nNypvHF2 {
  background: #483C83;
}
.KV0MFBItKn.h6HyzSrd7z {
  background: #58518d;
}
.KV0MFBItKn._mJYdl7oQX {
  background: #7068A9;
}
.KV0MFBItKn.r2cupKMaCR {
  background: #7f78b2;
}
.KV0MFBItKn.svCATOV3Tk {
  background: #8f88bc;
}
.KV0MFBItKn.ezBbtMVk0c {
  background: #000;
}
.KV0MFBItKn.kFxdAV8kJs {
  background: #282626;
}
.KV0MFBItKn.Orvq7JGc64 {
  background: #242222;
}
.KV0MFBItKn.ABQTlvussa {
  background: #353838;
}
.KV0MFBItKn.WJ2eRBBsWu {
  background: #666;
}
.KV0MFBItKn.cHRhbDVzaT {
  background: #999;
}
.zcgs2SbVJd {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.zcgs2SbVJd .Y7H4ukkG1R {
  display: none;
}
.NXlae70BDd {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}
.NXlae70BDd .N1M0P07h9L.N1M0P07h9L {
  background-color: #ccc;
  color: #121212;
  font-weight: 400;
}
.NXlae70BDd .iRSgGOhjjV {
  font-weight: 400;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `GSk0HVsePm`,
	"color-row": `GTb2GT7yyb`,
	"color-tile": `KV0MFBItKn`,
	"picker-component": `JcFslAH1Wx`,
	"picker-element": `KMK5q5zOT6`,
	"active": `puDx9f2q3X`,
	"btn": `N5x3KVtz4a`,
	"red-1": `KeM1XqFb48`,
	"red-2": `D0zJNLxFMc`,
	"red-3": `TgcPJbBPu9`,
	"red-4": `yVITea9Bgg`,
	"red-5": `lA87mL9vbc`,
	"red-6": `XEg79eUX1U`,
	"orange-1": `Y8Hzgqd_16`,
	"orange-2": `Sc4Snr2g0d`,
	"orange-3": `ldflf01xLC`,
	"orange-4": `hS0_i_Rzx7`,
	"orange-5": `hsGW4UzFe6`,
	"orange-6": `nBF9prrzz3`,
	"green-1": `TBGTFtNZ45`,
	"green-2": `loSOyM0NZp`,
	"green-3": `mcFA2agBOs`,
	"green-4": `zDcuW0Ninw`,
	"green-5": `UsSGfRSu9j`,
	"green-6": `LEHqmBVRlo`,
	"blue-1": `GW2ynH0BhY`,
	"blue-2": `G_Lu6QLngZ`,
	"blue-3": `bMAXY3JMl4`,
	"blue-4": `UGIKCQVAaB`,
	"blue-5": `VfATB2oFOe`,
	"blue-6": `EgcBet5ExD`,
	"yellow-1": `mddiS1knaD`,
	"yellow-2": `Jz5QVD0ubT`,
	"yellow-3": `rbNlL90SAV`,
	"yellow-4": `tPHXdmmPwC`,
	"yellow-5": `iCgUMlyQk3`,
	"yellow-6": `bL2k7Bo_eC`,
	"purple-1": `ZtXELSjfvU`,
	"purple-2": `w9nNypvHF2`,
	"purple-3": `h6HyzSrd7z`,
	"purple-4": `_mJYdl7oQX`,
	"purple-5": `r2cupKMaCR`,
	"purple-6": `svCATOV3Tk`,
	"black-1": `ezBbtMVk0c`,
	"black-2": `kFxdAV8kJs`,
	"black-3": `Orvq7JGc64`,
	"black-4": `ABQTlvussa`,
	"black-5": `WJ2eRBBsWu`,
	"black-6": `cHRhbDVzaT`,
	"picker-theme": `zcgs2SbVJd`,
	"arrow-regular": `Y7H4ukkG1R`,
	"editor-footer__root": `NXlae70BDd`,
	"footer--cancel-btn": `N1M0P07h9L`,
	"footer--save-btn": `iRSgGOhjjV`
};
export default ___CSS_LOADER_EXPORT___;
